import React from 'react'

const ConfirmationPopUp = ({ heading, subHeading, runFunction, closePopup, logout }) => {
    return (
        <div className='p-5 sm:min-w-[460px] flex flex-col gap-4'>
            <div className='flex items-center justify-between'>
                <h4>{heading}</h4>
            </div>
            <hr className='main-border-color' />
            <p className='text-base'>{subHeading}</p>
            <div className='flex items-center justify-start gap-2'>
                <button type='button' className={`${logout ? 'bg-red-500' : 'bg-primary'} flex items-center justify-center w-[130px] h-[40px] text-white text-sm rounded-lg mt-2 transition duration-300`} onClick={runFunction}>Yes</button>
                <button type='button' className='secondary-btn !w-[130px] mt-2' onClick={closePopup}>
                    No
                </button>
            </div>
        </div>
    )
}

export default ConfirmationPopUp